import React from "react";
import CommonOpacityBackground from "../../components/Common/commonOpacityBackground";
import CloseDetailPage from "../../components/CloseComponent/CloseDetailPage";
import { useTranslation } from "react-i18next";
import { HiChevronLeft } from "react-icons/hi";
import { useNavigate } from "react-router";

import service_image01 from "../../images/Service/911woman.png";
import viberQrcode from "../../images/Service/viberqr2.jpeg";

import { useDispatch, useSelector } from "react-redux";
import { Divider } from "semantic-ui-react";
import QRCode from "qrcode.react";
import { motion } from "framer-motion";
import { isLoggedIn } from "../../utils/isLoggedIn";
import { openChat } from "../../redux/action/member/memberAction";
import { COMMON_ALT } from "../../constant";

import tawk_bg from "../../images/Service/tawk-bg-n.png";
import zalo_bg from "../../images/Service/zalo-bg-n.png";
import line_bg from "../../images/Service/line-bg-n.png";
import telegram_bg from "../../images/Service/telegram-bg-n.png";
import fb_bg from "../../images/Service/fb-bg-n.png";
import viber_bg from "../../images/Service/viber-bg-n.png";

const appLink = [
  {
    label: "Tawk",
    link: "https://tawk.to/chat/5ec391176f7d401ccbb7d73b/default",
    background: tawk_bg,
    qrcode: "",
  },
  {
    label: "Zalo",
    link: "https://zaloapp.com/qr/p/tlxggf0qgiyy",
    background: zalo_bg,
    qrcode: "",
  },
  {
    label: "Line",
    link: "https://line.me/ti/p/2kyr2UfYam#~",
    background: line_bg,
    qrcode: "",
  },
  {
    label: "Telegram",
    link: "https://t.me/sub911win",
    background: telegram_bg,
    qrcode: "",
  },
  {
    label: "Facebook",
    link: "https://m.me/100433372189785",
    background: fb_bg,
    qrcode: "",
  },
  { label: "Viber", img: viberQrcode, background: viber_bg, qrcode: "" },
];

const ServicePage = () => {
  const { t } = useTranslation();
  const i18n_common = (key) => t(`common.${key}`);
  const i18n = (key) => t(`service.${key}`);

  const memberData = useSelector((state) => state.isMemberInfo);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const serviceGroup = [
    {
      label: "",
      link: `https://chatsys4.911win.fun/mobile/index/home?visiter_id=${memberData?.uid}&visiter_name=${memberData?.memId}&avatar=&business_id=admin&groupid=0&service_name=service01&lang=vn&ismobile=1`,
    },
  ];

  return (
    <CommonOpacityBackground path={-1} className="!items-center">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3 }}
        onClick={(e) => {
          e.stopPropagation();
        }}
        className="md:w-[650px] md:h-[80vh] w-full h-full pb-[20px]  overflow-y-scroll no-scrollbar bg-transaction-card dark:bg-base-light-dark md:rounded-[10px] px-[10px]"
      >
        <CloseDetailPage
          title={i18n_common("serviceInformation")}
          hasPrev={
            <HiChevronLeft
              onClick={() => {
                navigate(-1);
              }}
              className="cursor-pointer"
            />
          }
          customClose={<p></p>}
        />
        <section className="px-[20px]">
          <section className="rounded-[30px] px-[30px] py-[20px] min-h-[150px] relative flex justify-end items-center bg-gradient-to-r from-[#FFAA5E] to-[#FE8C07]">
            <img
              className="absolute w-[148px] bottom-0 left-[15px] md:left-[35px]"
              src={service_image01}
            />
            <div className="flex flex-col gap-[20px] items-center">
              <span className="text-2xl font-bold text-white tracking-tighter">
                Online Service
              </span>
              <div
                onClick={() => {
                  if (isLoggedIn()) {
                    dispatch(openChat());
                  } else {
                    navigate("/casino/signin");
                  }
                }}
                className="py-[5px] cursor-pointer rounded-full bg-gradient-to-r from-[#6C6C6C] to-[#979795] shadow px-[20px] text-white font-bold"
              >
                CALL NOW
              </div>
            </div>
          </section>
        </section>
        {/* <Divider /> */}
        <div className="dark:text-base-light-white text-base-light-dark text-xl font-medium px-[20px] my-[20px] text-start">
          {i18n("mobileAppService")}
        </div>
        <section className="grid grid-cols-2 md:grid-cols-3 gap-[20px] md:gap-[10px]">
          {appLink.map((item) => {
            return (
              <div
                className="flex flex-col items-center gap-[5px] dark:text-base-light-white text-base-light-dark w-[160px] h-[160px] mx-auto bg-cover relative"
                style={{
                  backgroundImage: `url(${item.background})`,
                }}
              >
                <div className="bg-base-white absolute top-[15px] right-[15px] p-[10px] rounded-[15px]">
                  {item.img ? (
                    <img
                      className="w-[50px] h-[50px]"
                      src={item.img}
                      alt={COMMON_ALT}
                    />
                  ) : (
                    <a
                      href={window?.communityInfo?.[item]?.info}
                      target="_blank"
                    >
                      <QRCode
                        className=" !w-[50px] !h-[50px]"
                        value={window?.communityInfo?.[item]?.qrcode}
                        // imageSettings={{
                        //     src:item.icon,
                        //     x: undefined,
                        //     y: undefined,
                        //     height: 24,
                        //     width: 24,
                        //     excavate: true,
                        //   }}
                      />
                    </a>
                  )}
                </div>
              </div>
            );
          })}
        </section>
        <div className="dark:text-base-light-white text-base-light-dark text-xl font-medium px-[20px] my-[20px] text-start">
          {i18n("contactInformation")}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-[20px] dark:text-base-light-white text-base-light-dark px-[20px]">
          <div className="flex flex-col items-start border-l border-main-color pl-[10px]">
            <p className="font-semibold text-main-color text-sm mb-0">
              {i18n("chineseVoiceService")}
            </p>
            <div className="flex flex-col items-start">
              <span className="font-bold text-xl text-main-color">
                +85587862496
              </span>
              <span className="text-sm">{i18n("hint1")}</span>
            </div>
          </div>
          <div className="flex flex-col items-start border-l border-main-color pl-[10px]">
            <p className="font-semibold text-main-color text-sm mb-0">
              {i18n("emailService")}
            </p>
            <div className="flex flex-col items-start">
              <span className="font-bold text-xl text-main-color">
                911win6688@gmail.com
              </span>
              <span className="text-sm">{i18n("hint2")}</span>
            </div>
          </div>
        </div>
      </motion.div>
    </CommonOpacityBackground>
  );
};

export default ServicePage;
